import { useState } from "react";
import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle, Input, Label } from "@patient-watch/ui";
import { useAdminAccess } from "../stores/adminAccessStore";

interface AdminPasswordGateProps {
    title?: string;
    description?: string;
    children: React.ReactNode;
}

export function AdminPasswordGate({
    title = "Admin Access",
    description = "Enter the study admin password to continue.",
    children,
}: AdminPasswordGateProps) {
    const { isUnlocked, unlock } = useAdminAccess();
    const [password, setPassword] = useState("");
    const [error, setError] = useState<string | null>(null);

    if (isUnlocked) {
        return <>{children}</>;
    }

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        const success = unlock(password);
        if (!success) {
            setError("Incorrect password. Please try again.");
            return;
        }
        setError(null);
    };

    return (
        <div className="flex justify-center items-center mt-40 p-4">
            <Card className="w-full max-w-md">
                <CardHeader>
                    <CardTitle>{title}</CardTitle>
                    <CardDescription>{description}</CardDescription>
                </CardHeader>
                <CardContent>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="space-y-2">
                            <Label htmlFor="admin-password">Password</Label>
                            <Input
                                id="admin-password"
                                type="password"
                                autoComplete="current-password"
                                value={password}
                                onChange={(event) => setPassword(event.target.value)}
                            />
                        </div>
                        {error ? <p className="text-red-600 text-sm">{error}</p> : null}
                        <Button type="submit" className="w-full">
                            Continue
                        </Button>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
}
